<template>
  <transition name="fade">
    <div class="homePage">
      <div class="homePageContent">
        <div class="homeTop">
          <img class="home__img" height="250" src="../assets/img/homeImg.png" alt="">
          <div class="home__brand">
            <h1>fmixlab Multimedia</h1>
            <h2>Graphic design &amp; Web development</h2>
          </div>
        </div>
        <div class="homeBottom">
          <p>Working from the concept and design of a project to the final integration and development.</p>
          <p><strong>For all your needs in digital content creation contact me at:</strong></p>
          <div class="homePage__contactInfo">
            <ul class="homePage__contactInfo__list">
              <li class="homePage__contactInfo__Bloc">
                <a href="mailto:fmixagent@gmail.com">
                  <span class="icon fmix-mail"></span>
                  fmixagent@gmail.com
                </a>
              </li>
              <li class="homePage__contactInfo__Bloc">
                <a href="skype:fmixagent?call">
                  <span class="icon fmix-skype"></span>
                  fmixagent
                </a>
              </li>
            </ul>
          </div>
          <p>For more information about my professional background and experience visit
            <a href="http://es.linkedin.com/pub/daniel-de-fuenmayor/2/428/b84">
              my LinkedIn profile
              <span class="icon fmix-linkedin"></span>
            </a>
          </p>
          <p>Or just explore some of the projects I have done as a freelance.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'HomePage',
  components: { },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.homePage {
  padding: $gutter;
  height: auto;
  min-height: 100%;
  padding-top: 80px;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;

  .homeTop {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: $baseDarkGrey;
    .home__img {
      margin-top: $gutter;
      margin-bottom: $gutter/2;
    }
    .home__brand {
      display: inline-block;
      h1 {
        font-size: 2rem;
      }
      h2 {
        font-size: 1.1rem;
        margin-top: -6px;
      }
    }
  }
  .homeBottom {
    max-width: 450px;
    margin: 0 auto;
    margin-top: $gutter;
  }
  @media (min-width: 768px) {
    padding: 40px;
  }
  .homePage__contactInfo {
    text-align: center;
    .homePage__contactInfo__list {
      list-style: none;
      padding: 0;
      display: inline-block;
      .homePage__contactInfo__Bloc {
        margin-bottom: 10px;
        text-align: left;
      }
    }
  }
  a {
    font-size: 1.3rem;
    color: $baseDarkGrey;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
    .icon {
      color: $baseLightGrey;
      text-decoration: none !important;
      display: inline-block;
      width: $gutter;
    }
    .fmix-mail {
      font-size: 1.2em;
      position: relative;
      top: 4px;
    }
    .fmix-linkedin {
      font-size: 1.1em;
      width: 20px;
      margin-right: 0.4em;
    }
  }
  h1 {
    margin-top: 0;
  }
}
/* TRANSITIONS */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue